<template>
  <div class="recycler-detail-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/" style="margin-bottom: 20px;">
      <el-breadcrumb-item>{{ detailData.deviceName }}详情</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 加载状态 -->
    <div v-loading="loading" style="min-height: 600px;">
      <!-- 基础信息卡片 -->
      <el-card class="info-card" shadow="hover">
        <!-- <div slot="header" class="card-header">
          <span>设备基础信息</span>
          <el-button size="mini" type="primary" @click="handleEdit">编辑</el-button>
        </div> -->

        <el-row :gutter="20" class="info-row">
          <!-- 左列：文本信息 -->
          <el-col :span="16">
            <el-form label-width="120px" :model="detailData" class="info-form">
              <el-row :gutter="16">
                <!-- 设备名称 -->
                <el-col :span="12">
                  <el-form-item label="设备名称">
                    <span class="info-text">{{ detailData.deviceName || '-' }}</span>
                  </el-form-item>
                </el-col>
                <!-- 设备号 -->
                <el-col :span="12">
                  <el-form-item label="设备号">
                    <span class="info-text">{{ detailData.deviceNo || '-' }}</span>
                  </el-form-item>
                </el-col>
                <!-- 点位地址 -->
                <el-col :span="12">
                  <el-form-item label="点位地址">
                    <span class="info-text">{{ detailData.address || '-' }}</span>
                  </el-form-item>
                </el-col>
                <!-- 设备状态（适配1-隐藏/2-离线/3-在线/4-故障） -->
                <el-col :span="12">
                  <el-form-item label="设备状态">
                    <el-tag
                      :type="getStatusTagType(detailData.deviceStatus)"
                      size="medium"
                    >
                      {{ getStatusText(detailData.deviceStatus) }}
                    </el-tag>
                  </el-form-item>
                </el-col>
                <!-- 已用容量 -->
                <el-col :span="12">
                  <el-form-item label="已用容量">
                    <div class="capacity-wrap">
                      <span class="capacity-value">{{ detailData.usedCapacity || 0 }}</span>
                      <el-progress
                        :percentage="(detailData.usedCapacity || 0) * 10"
                        style="width: 200px; margin-left: 10px;"
                      />
                    </div>
                  </el-form-item>
                </el-col>
                <!-- 社区 -->
                <el-col :span="12">
                  <el-form-item label="社区">
                    <span class="info-text"> {{ detailData.streetName || '' }}-{{ detailData.communityName || '' }}</span>
                  </el-form-item>
                </el-col>
                <!-- 经度 -->
                <el-col :span="12">
                  <el-form-item label="经度">
                    <span class="info-text">{{ detailData.longitude || '-' }}</span>
                  </el-form-item>
                </el-col>
                <!-- 纬度 -->
                <el-col :span="12">
                  <el-form-item label="纬度">
                    <span class="info-text">{{ detailData.latitude || '-' }}</span>
                  </el-form-item>
                </el-col>
                <!-- 创建时间 -->
                <el-col :span="12">
                  <el-form-item label="创建时间">
                    <span class="info-text">{{ formatTime(detailData.createTime) || '-' }}</span>
                  </el-form-item>
                </el-col>
                <!-- 定位跳转 -->
                <!-- <el-col :span="12">
                  <el-form-item label="地理位置">
                    <el-button
                      type="text"
                      @click="openMap"
                      v-if="detailData.longitude && detailData.latitude"
                    >
                      <i class="el-icon-location"></i> 查看地图定位
                    </el-button>
                    <span class="info-text" v-else>-</span>
                  </el-form-item>
                </el-col> -->
              </el-row>
            </el-form>
          </el-col>

          <!-- 右列：展示图片 -->
          <el-col :span="8">
            <div class="img-card">
              <div class="img-title">设备展示图片</div>
              <div class="img-list">
                <!-- 单张图片 -->
                <div v-if="detailData.picUrl && !Array.isArray(detailData.picUrl)" class="img-item">
                  <el-image
                    :src="detailData.picUrl"
                    fit="cover"
                    style="width: 100%; height: 280px; border-radius: 4px;"
                    @click="previewImage(detailData.picUrl)"
                    :preview-src-list="[detailData.picUrl]"
                  />
                </div>
                <!-- 多张图片 -->
                <div v-else-if="detailData.picUrl && Array.isArray(detailData.picUrl)" class="img-grid">
                  <el-image
                    v-for="(url, index) in detailData.picUrl"
                    :key="index"
                    :src="url"
                    fit="cover"
                    style="width: 100%; height: 130px; border-radius: 4px; margin-bottom: 10px;"
                    @click="previewImage(url)"
                    :preview-src-list="detailData.picUrl"
                  />
                </div>
                <!-- 无图片 -->
                <div v-else class="img-placeholder">
                  <el-empty description="暂无设备展示图片" />
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <!-- 桶内订单入口 -->
      <el-card class="order-card" shadow="hover" style="margin-top: 20px;">
        <div slot="header" class="card-header">
          <span style="margin-right: 10px;">桶内订单</span>
          <el-button size="mini" type="primary" @click="openOrderDialog">查看订单</el-button>
        </div>
        <div class="order-tip">
          点击按钮查看该设备下所有桶内订单数据
        </div>
      </el-card>
    </div>

    <!-- 图片预览弹窗 -->
    <el-dialog title="设备图片预览" :visible.sync="previewVisible" width="60%">
      <img :src="previewImageUrl" style="width: 100%;" />
    </el-dialog>

    <!-- 桶内订单弹框 -->
    <el-dialog
      :title="`【${detailData.deviceName || '未知设备'}】桶内订单`"
      :visible.sync="orderDialogVisible"
      width="90%"
      top="20px"
      append-to-body
    >
      <!-- 订单弹框内部内容 -->
      <div class="order-dialog-content" v-loading="orderLoading">
        <el-table :data="orderList" border stripe style="width: 100%;">
          <el-table-column prop="id" label="订单ID"  align="center" />
          <el-table-column prop="orderNo" label="订单编号" width="180" align="center" />
          <el-table-column prop="recycleType" label="回收类型" width="120" align="center" >
            <template slot-scope="scope">
              <el-tag size="mini">
                  可回收物
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="weight" label="重量(kg)"  align="center" />
          <el-table-column prop="totalPrice" label="金额(元)"  align="center" />
          <el-table-column prop="createTime" label="创建时间"  align="center">
            <template slot-scope="scope">
              {{ formatTime(scope.row.createTime) }}
            </template>
          </el-table-column>
        </el-table>
        <!-- 订单分页 -->
        <!-- <el-pagination
          @size-change="handleOrderSizeChange"
          @current-change="handleOrderCurrentChange"
          :current-page="orderPagination.pageNum"
          :page-sizes="[10, 20, 50]"
          :page-size="orderPagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="orderPagination.total"
          style="text-align: right; margin-top: 20px;"
        /> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import { 
  getWlRecycleDeviceDetail, 
  getWlRecycleDeviceOrder, 
  getStreet,
  getCommunity
} from "@/api/recyclingMachine";

export default {
  name: "RecyclingMachineDetail",
  data() {
    return {
      loading: false,
      orderLoading: false, // 订单加载状态
      previewVisible: false,
      previewImageUrl: '',
      orderDialogVisible: false,
      detailData: { 
        deviceName: '',
        deviceNo: '',
        address: '',
        deviceStatus: 0, 
        usedCapacity: 0, // int32类型（0-10）
        longitude: '',
        latitude: '',
        createTime: '',
        picUrl: '',
        wlStreetId: '',
        wlCommunityId: '',
        streetName: '', // 补充初始化
        communityName: '' // 补充初始化
      },
      orderList: [], // 桶内订单数据
      orderPagination: { // 订单分页参数
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      communityResAll: [],
      communityNameArr: []
    };
  },
  
  async created() {
    // 获取路由参数中的设备ID
    const deviceId = this.$route.params.id;
    if (deviceId) {
      try {
        // 获取街道列表
        const streetRes = await getStreet();
        this.communityNameArr = streetRes.data || [];
        // 获取全量社区列表（优化：传递空参数避免接口报错）
        const communityRes = await getCommunity({});
        this.communityResAll = communityRes.data || [];
        // 调用设备详情接口
        await this.getWlRecycleDeviceDetail(deviceId);
      } catch (error) {
        console.error('初始化数据失败：', error);
        this.$message.warning('数据加载失败，请刷新页面');
      }
    }
  },
  methods: {
    // 时间格式化
    formatTime(time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-';
    },

    /**
     * 调用设备详情接口 
     * @param {Number} deviceId 设备ID（int32类型）
     */
    async getWlRecycleDeviceDetail(deviceId) {
      this.loading = true;
      try {
        const res = await getWlRecycleDeviceDetail({id:Number(deviceId)});
        if (res.code === 200) {
          this.detailData = { ...this.detailData, ...res.data };
          // 确保数字类型字段正确转换
          this.detailData.deviceStatus = Number(this.detailData.deviceStatus) || 0;
          this.detailData.usedCapacity = Number(this.detailData.usedCapacity) || 0;
          
          // 匹配社区名称
          if (!_.isEmpty(this.communityResAll)) {
            const community = this.communityResAll.find(comm => 
              comm.id === _.toNumber(_.get(this.detailData, 'wlCommunityId'))
            );
            this.detailData.communityName = community ? community.name : '';
          }
          
          // 匹配街道名称
          if (!_.isEmpty(this.communityNameArr)) {
            const street = this.communityNameArr.find(str => 
              str.id === _.toNumber(_.get(this.detailData, 'wlStreetId'))
            );
            this.detailData.streetName = street ? street.name : '';
          }
        }
      } catch (error) {
        console.error("调用getWlRecycleDeviceDetail失败：", error);
        this.$message.error("设备详情加载失败，请重试");
      } finally {
        this.loading = false;
      }
    },

    /**
     * 调用桶内订单接口 
     * @param {Number} deviceId 设备ID（int32类型）
     */
    async getWlRecycleDeviceOorderDetail(deviceId) {
      this.orderLoading = true;
      try {
        // 修复：统一使用封装的接口，替换axios原生调用
        const res = await getWlRecycleDeviceOrder({
          deviceId: Number(deviceId),
          pageNo: this.orderPagination.pageNum,
          pageSize: this.orderPagination.pageSize
        });
        if (res.code === 200) {
          this.orderList = res.data || [];
        }
      } catch (error) {
        console.error("调用订单接口失败：", error);
        this.$message.error("订单数据加载失败，请重试");
      } finally {
        this.orderLoading = false;
      }
    },

    // 设备状态文本转换
    getStatusText(status) {
      const statusMap = {
        1: '隐藏',
        2: '离线',
        3: '在线',
        4: '故障'
      };
      return statusMap[status] || '未知状态';
    },

    // 设备状态标签类型
    getStatusTagType(status) {
      const typeMap = {
        1: 'default',  // 隐藏-灰色
        2: 'danger',   // 离线-红色
        3: 'success',  // 在线-绿色
        4: 'warning'   // 故障-黄色
      };
      return typeMap[status] || 'default';
    },

    // 预览图片
    previewImage(url) {
      // this.previewImageUrl = url;
      // this.previewVisible = true;
    },

    // 打开地图定位
    openMap() {
      const { longitude, latitude, deviceName } = this.detailData;
      // 修复：高德地图URL格式错误
      const mapUrl = `https://amap.com/marker?position=${longitude},${latitude}&name=${encodeURIComponent(deviceName)}`;
      window.open(mapUrl, '_blank');
    },

    // 编辑设备（修复路由参数错误）
    handleEdit() {
      this.$router.push({
        path: '/recycler/edit',
        params: { id: this.$route.params.id } // 改为params传递ID
      });
    },

    // 打开桶内订单弹框
    openOrderDialog() {
      this.orderDialogVisible = true;
      this.orderPagination.pageNum = 1; // 重置订单页码
      this.getWlRecycleDeviceOorderDetail(this.detailData.id);
    },

    // 订单分页-每页条数变化
    handleOrderSizeChange(val) {
      this.orderPagination.pageSize = val;
      this.orderPagination.pageNum = 1;
      this.getWlRecycleDeviceOorderDetail(this.detailData.id);
    },

    // 订单分页-页码变化
    handleOrderCurrentChange(val) {
      this.orderPagination.pageNum = val;
      this.getWlRecycleDeviceOorderDetail(this.detailData.id);
    }
  }
};
</script>

<style scoped>
.recycler-detail-container {
  padding: 20px;
  background: #f7f7f7;
  min-height: calc(100vh - 60px);
}
.info-card {
  background: #fff;
  border-radius: 4px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
}
.info-row {
  margin-top: 10px;
}
.info-form {
  padding: 10px 0;
}
.info-text {
  font-size: 14px;
  color: #666;
}
.capacity-wrap {
  display: flex;
  align-items: center;
}
.capacity-value {
  font-size: 14px;
  color: #333;
  font-weight: 600;
}
.img-card {
  background: #f8f8f8;
  padding: 10px;
  border-radius: 4px;
  height: 100%;
}
.img-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
}
.img-list {
  width: 100%;
}
.img-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.img-placeholder {
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 4px;
}
.order-card {
  background: #fff;
  border-radius: 4px;
}
.order-tip {
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
}
.order-dialog-content {
  padding: 10px 0;
}
</style>